import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { computed, unref } from 'vue';
import { getApi } from './api';

export interface GetAccountDevicesParams {
    with_current_position?: boolean;
    subscription_status?: string;
    exclude_groups?: boolean;
    /** Comma-separated device statuses (same as subscription_status pattern). Default on backend: active. Values: active, provisioned, hidden. */
    device_status?: string;
    [key: string]: any;
}

const DEFAULT_DEVICE_STATUS = 'active';

function normalizeParams(params: GetAccountDevicesParams | undefined): GetAccountDevicesParams {
    const p = params ?? {};
    return {
        exclude_groups: true,
        device_status: p.device_status ?? DEFAULT_DEVICE_STATUS,
        ...p,
    };
}

export default (
    accountId: Ref<number> | number,
    params?: Ref<GetAccountDevicesParams> | GetAccountDevicesParams
) => {
    return useQuery({
        queryKey: [
            'account-devices',
            () => unref(accountId),
            () => normalizeParams(unref(params))
        ],
        queryFn: () => {
            const { api, baseURL } = getApi();
            const actualAccountId = unref(accountId);
            const queryParams = normalizeParams(unref(params));
            return api.get(`/api/accounts/${actualAccountId}/device-list`, {
                baseURL,
                params: queryParams
            }).then(res => res.data.data);
        },
        enabled: computed(() => !!unref(accountId)),
    });
}
